import { NgModule } from '@angular/core';
import { ptBR } from 'date-fns/locale';

import { DateAdapter } from './date-adapter';
import { AppDateFnsAdapter } from './app-date-fns-adapter';
import {
  APP_DATE_FORMATS,
  APP_DATE_LOCALE,
  AppDateFormats,
} from './app-date-formats';

export const APP_DATE_FNS_FORMATS: AppDateFormats = {
  parse: { dateInput: 'dd/MM/yyyy' },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'PP',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@NgModule({
  providers: [
    { provide: APP_DATE_LOCALE, useValue: ptBR },
    {
      provide: DateAdapter,
      useClass: AppDateFnsAdapter,
      deps: [APP_DATE_LOCALE],
    },
    { provide: APP_DATE_FORMATS, useValue: APP_DATE_FNS_FORMATS },
  ],
})
export class AppDateFnsModule {}
